export const toReduxStore = (profile) => {
  const {rut, phone, name, email, fatherLastName, motherLastName} = profile;

  return {
    profile,
    phone,
    unique_id: profile.unique_id,
    email,
    lastName: motherLastName,
    name,
    rut,
    firstName: fatherLastName,
    fullName: `${name} ${fatherLastName}`,
  }
}
